import { Component, EventEmitter, Input, NgZone, Output, Renderer2 } from '@angular/core';
import { DeviceService } from '../../../services/device.service';
import { WindowRefService } from '../../../services/window.service';
import { Device, GpsState, ConnectionState } from '../models';

@Component({
  selector: 'google-device-map',
  templateUrl: './google-device-map.component.html',
  styleUrls: ['./google-device-map.component.scss'],
  providers: [WindowRefService],
})
export class GoogleDeviceMapComponent {

  icvIcon = "/angular/webforms/assets/img/camera-realtime-map/icv.svg";
  bwcIcon = "/angular/webforms/assets/img/camera-realtime-map/bwc.svg";
  recordingIcon = "/angular/webforms/assets/img/camera-realtime-map/recording.svg";
  streamingIcon = "/angular/webforms/assets/img/camera-realtime-map/streaming.svg";

  resetZoomButtonIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224%22%20viewBox%3D%220%20-960%20960%20960%22%20width%3D%2224%22%3E%3Cpath%20fill%3D%22%23666%22%20%20d%3D%22M800-600v-120H680v-80h120q33%200%2056.5%2023.5T880-720v120h-80Zm-720%200v-120q0-33%2023.5-56.5T160-800h120v80H160v120H80Zm600%20440v-80h120v-120h80v120q0%2033-23.5%2056.5T800-160H680Zm-520%200q-33%200-56.5-23.5T80-240v-120h80v120h120v80H160Zm80-160v-320h480v320H240Zm80-80h320v-160H320v160Zm0%200v-160%20160Z%22%2F%3E%3C%2Fsvg%3E";
  userLocationButtonIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224%22%20viewBox%3D%220%20-960%20960%20960%22%20width%3D%2224%22%3E%3Cpath%20fill%3D%22%23666%22%20%20d%3D%22M440-42v-80q-125-14-214.5-103.5T122-440H42v-80h80q14-125%20103.5-214.5T440-838v-80h80v80q125%2014%20214.5%20103.5T838-520h80v80h-80q-14%20125-103.5%20214.5T520-122v80h-80Zm40-158q116%200%20198-82t82-198q0-116-82-198t-198-82q-116%200-198%2082t-82%20198q0%20116%2082%20198t198%2082Zm0-120q-66%200-113-47t-47-113q0-66%2047-113t113-47q66%200%20113%2047t47%20113q0%2066-47%20113t-113%2047Zm0-80q33%200%2056.5-23.5T560-480q0-33-23.5-56.5T480-560q-33%200-56.5%2023.5T400-480q0%2033%2023.5%2056.5T480-400Zm0-80Z%22%2F%3E%3C%2Fsvg%3E";
  userLocationMarkerIcon = "M 100, 100 m 75, 0 a 75, 75 0 1, 0 -150, 0 a 75, 75 0 1, 0  150, 0";
  searchButtonIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224%22%20viewBox%3D%220%20-960%20960%20960%22%20width%3D%2224%22%3E%3Cpath%20fill%3D%22%23666%22%20%20d%3D%22M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z%22%2F%3E%3C%2Fsvg%3E";
  closeSearchButtonIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2224%22%20viewBox%3D%220%20-960%20960%20960%22%20width%3D%2224%22%3E%3Cpath%20fill%3D%22%23666%22%20%20d%3D%22m256-200-56-56%20224-224-224-224%2056-56%20224%20224%20224-224%2056%2056-224%20224%20224%20224-56%2056-224-224-224%20224Z%22%20%2F%3E%3C%2Fsvg%3E";

  private _devices: Device[] = [];
  markers: Device[] = [];
  searchButton: any;
  searchOpen: boolean = false;
  loaded: boolean = false;
  bwcFilterButton: HTMLElement;
  icvFilterButton: HTMLElement;
  recordingFilterButton: HTMLElement;
  streamingFilterButton: HTMLElement;

  @Input() set devices(value: Device[]) {


    console.log(value);
    this._devices = value.filter(device => device.gpsState != GpsState.Old);

    console.log(value);
    // Update device markers
    this.setMarkers(this._devices);

    // If a marker is selected, recenter the map on it
    this.updateTracking();
  }

  @Output() streamRequest = new EventEmitter();
  @Output() searchClick = new EventEmitter<boolean>(this.searchOpen);

  userLocationMarker: any;
  userLocation: any;
  map: google.maps.Map;

  options: google.maps.MapOptions = {
    center: { lat: 0, lng: 0 },
    zoom: 2,
    mapTypeControl: true,
    mapTypeControlOptions: {
      position: google.maps.ControlPosition.BOTTOM_CENTER,
      mapTypeIds: ["roadmap", "terrain", "satellite"],
    },
  };

  constructor(private renderer: Renderer2,
    private deviceService: DeviceService,
    private zone: NgZone) {
  }

  getMarkerTitle(item: Device): string {
    let title = `${item.name}`;
    if (item.gpsState == GpsState.Unknown) {
      title += `. GPS lost, last seen: ${item.gpsLocationTime.toLocaleString()}`;
    }
    // Debug
    //title += ` GPS ${GpsState[item.gpsState].toString()},  Status ${ConnectionState[item.status]}, UI Online ${ConnectionState[item.connectionState]}, ${item.gpsAgeOfData}, ${item.gpsLocationTime}, ${item.gpsLocationTime.getTime() + (item.gpsStaleTimeout * 1000) < Date.now()}, ${item.gpsStaleTimeout}`;
    return title;
  }

  // Add map marker properties to the devices
  private setMarkers(devices: Device[]) {

    let satellite = this.map?.getMapTypeId() == "satellite";

    // Set the marker properties for each device
    this.markers = devices
      // Set the Marker properties for each device
      .map((item: Device) => {

        item.position = {
          lat: item.gpsLatitude,
          lng: item.gpsLongitude
        };

        item.options = {
          zIndex: 99999,
          optimized: true,
        };

        item.title = this.getMarkerTitle(item);

        let opacity = item.gpsState == GpsState.Old ? 0 : item.gpsState == GpsState.Unknown ? 0.5 : 1;

        item.icon = {
          path: item.iconPath,
          scale: item.sourceType == 0 ? 0.8 : 0.25,
          scaledSize: new google.maps.Size(30, 20),
          anchor: item.sourceType == 0 ? new google.maps.Point(25, 25) : new google.maps.Point(55, 70),
          rotation: item.sourceType == 0 ? item.gpsHeading : 0,
          fillColor: item.isStreaming ? '#f20d24' : satellite ? '#007bff' : '#17191c',
          fillOpacity: opacity,
          strokeWeight: 1,
          strokeOpacity: 0.6,
          strokeColor: item.uiState.selected ? '#00aeef' : item.uiState.highlighted ? '#0076a2' : '#fff',
        };

        return item;
      });


    // The first time the devices are loaded, reset the zoom level
    if (devices.length > 0 && this.map && !this.loaded) {
      this.resetZoom();
      this.loaded = true;
    }

  }

  public mapTypeChanged() {

  }

  // When the map has loaded, populate the initial markers
  public onMapReady(map: google.maps.Map): void {

    this.map = map;
    this.setMarkers(this._devices);

    this.addControl("Show all cameras", google.maps.ControlPosition.RIGHT_BOTTOM, () => this.resetZoom(), this.resetZoomButtonIcon);

    this.searchButton = this.addControl("Search", google.maps.ControlPosition.TOP_LEFT, () => this.toggleSearch(), this.searchButtonIcon);

    this.bwcFilterButton = this.addToggle("Show only Body Worn Cameras", google.maps.ControlPosition.TOP_LEFT, () => this.deviceService.toggleBwc(), null, "BWC", true);
    this.icvFilterButton = this.addToggle("Show only In Car Cameras", google.maps.ControlPosition.TOP_LEFT, () => this.deviceService.toggleIcv(), null, "ICV", true);
    this.streamingFilterButton = this.addToggle("Show only Streaming Cameras", google.maps.ControlPosition.TOP_LEFT, () => this.deviceService.toggleStreaming(), null, "Streaming");
    this.recordingFilterButton = this.addToggle("Show only Recording Cameras", google.maps.ControlPosition.TOP_LEFT, () => this.deviceService.toggleRecording(), null, "Recording");

    // If the browser supports HTML5 geolocation API, show the user location button
    if (navigator.geolocation) {
      this.addControl("Show user location", google.maps.ControlPosition.RIGHT_BOTTOM, () => this.setUserPosition(), this.userLocationButtonIcon);
    }

    this.options.mapTypeControl = true;
  }

  private toggleSearch() {
    this.searchOpen = !this.searchOpen;

    this.searchButton.childNodes[0].src = this.searchOpen ? this.closeSearchButtonIcon : this.searchButtonIcon;
    this.searchClick.emit(this.searchOpen);
  }

  // This function gets the user's geolocation and adds a marker to the map at that location. // Make sure to add the function to the appropriate location in the existing code.
  private setUserPosition(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        this.userLocationMarker = {
          path: this.userLocationMarkerIcon,
          scale: 0.07,
          fillOpacity: 1,
          strokeWeight: 2,
          fillColor: '#5384ED',
          anchor: new google.maps.Point(7, 7),
          strokeColor: '#ffffff',
        };

        this.userLocation = pos;
        this.map.setCenter(pos);
      }, () => {
        console.log("Could not retrieve user location");
      });
    } else { console.log("Geolocation is not supported by this browser."); }
  }

  // Adds a toggle button to the map
  private addToggle(label, position, action, icon, text, enabled = false) {
    const button = this.addControl(label, position, () => {
      button.classList.toggle("active");
      action();
    }, icon, text);
    if (enabled) {
      button.classList.add("active");
    }
    return button;
  };

  // Adds a custom control to the map
  private addControl(title: string, position: google.maps.ControlPosition, callback: any, icon: string, text: string = null): HTMLElement {

    // Create the button
    const button = this.renderer.createElement("button");
    button.type = "button";
    button.title = title;
    button.classList.add("mapButton");

    if (icon != null) {
      // Create the icon for the button
      const buttonIcon = this.renderer.createElement("img");
      buttonIcon.src = icon;
      this.renderer.appendChild(button, buttonIcon);
    }
    if (text != null) {
      // Create the text label for the button
      const buttonLabel = this.renderer.createElement("span");
      buttonLabel.classList.add("mapButtonLabel");
      buttonLabel.innerText = text;
      this.renderer.appendChild(button, buttonLabel);
    }

    this.map.controls[position].push(button);
    this.renderer.listen(button, 'click', callback);

    return button;
  }

  clearTracking() {
    this.deviceService.deselectDevices();
  }

  highlightMarker(device: Device) {
    this.deviceService.setDeviceHighlight(device, true);
  }

  unHighlightMarker(device: Device) {
    this.deviceService.setDeviceHighlight(device, false);
  }

  updateTracking() {

    let selectedMarker = this.markers.find(m => m.uiState.selected);

    if (selectedMarker) {
      this.map.setCenter(selectedMarker.position);
    }
  }

  // Zooms the map to fit all the markers
  public resetZoom() {

    if (this.markers.length == 0) return;

    let bounds = new google.maps.LatLngBounds();

    for (const element of this.markers) {
      bounds.extend(element.position);
    }

    this.map.setCenter(bounds.getCenter());
    this.map.fitBounds(bounds);
    this.map.setZoom(this.map.getZoom());

    // set a minimum zoom
    // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
    if (this.map.getZoom() > 15) {
      this.map.setZoom(15);
    }
  }

  // Placeholder function for handling marker clicks
  openMeta(marker: Device, meta: Device) {
    if (!marker) {
      return;
    }

    this.streamRequest.emit(meta);
    this.deviceService.setDeviceSelected(meta);

    // Open an InfoWindow to display stream etc.
  }

}
